import React from "react";
import LayoutComponent from "@ui/layout/LayoutComponent";
import {Badge, Breadcrumb, Button, Input, Pagination} from "antd";
import {SecurityScanOutlined, SolutionOutlined, UnorderedListOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import "./concluded-system.scss";
import {concludedSystemsData} from "@store/concludedSystemsData";


const ConcludedSystems = () => {

    return (
        <LayoutComponent>
            <div className="breadcrumb">
                <Breadcrumb
                    style={{
                        margin: '16px 0',
                    }}
                >
                    <Breadcrumb.Item>
                        <UnorderedListOutlined/>
                        <span>Список</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={'/systems'}>
                            <SecurityScanOutlined/>
                            <span>Испытания</span>
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <SolutionOutlined/>
                        <span>На стадии заключения</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div className="concluded-container">
                <div className="card">
                    <div className="card-body">
                        <div className="card-title">Таблица испытаний: на стадии заключения</div>
                        <div className="search-wrapper">
                            <div className="search-block">
                                <div className="search-input">
                                    <Input placeholder="поиск по названию ОИ" />
                                </div>
                                <Button type="primary">Найти</Button>
                            </div>
                        </div>
                        <table>
                            <thead>
                            <tr>
                                <th>Объект испытания</th>
                                <th>Заявитель</th>
                                <th>Владелец</th>
                                <th>Виды испытаний</th>
                                <th>Статус</th>
                            </tr>
                            </thead>
                            <tbody>
                            {concludedSystemsData.map((system) => (
                                <tr key={system.id}>
                                    <td>{system.systemName}</td>
                                    <td>{system.applicant}</td>
                                    <td>{system.owner}</td>
                                    <td>{system.workType}</td>
                                    <td><Badge status={system.statusIndicator}/>{system.status}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <div className="pagination">
                            <Pagination defaultCurrent={1} total={50}/>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutComponent>
    )
}

export default ConcludedSystems;